import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ReactSession } from "../../lib/secure_reactsession";
import { showToast } from "../../lib/helpers";
import { saveTestResultQuestion } from "../../services/test_result";
import GlobalQuestion from "./global-question";

export default function Question({
    test,
    result,
    questionCallback,
    questionType,
    timeSpent,
}) {
    const location = useLocation();
    const [isActiveQuestion, setActiveQuestion] = useState(1);
    const [totalQuestion, setTotalQuestion] = useState(0);
    const [QuestionArrayList, setQuestionArrayList] = useState([]);
    const [questionLoading, setQuestionLoading] = useState(false);
    const [questionArray, setQuestionArray] = useState([]);
    const [skippedCount, setSkippedCount] = useState(0);

    useEffect(() => {
        let Questions = [];

        if (questionType === "briefing") {
            if (test && test.briefing_question.length) {
                setActiveQuestion(1);
                setTotalQuestion(test && test.briefing_question.length);

                test && test.briefing_question.forEach((items) => {
                    Questions.push({
                        data: items,
                        questionData: JSON.parse(items.questions),
                    });
                });

                setQuestionArrayList(Questions);
            } else {
                saveQuestionData([], true);
            }
        } else {
            if (test && test.debriefing_question.length) {
                setActiveQuestion(1);
                setTotalQuestion(test && test.debriefing_question.length);

                test && test.debriefing_question.forEach((items) => {
                    Questions.push({
                        data: items,
                        questionData: JSON.parse(items.questions),
                    });
                });

                setQuestionArrayList(Questions);
            } else {
                saveQuestionData([], true);
            }
        }

        window.scrollTo(0, 0);
    }, []);

    const handleNext = (formData) => {
        setQuestionArray([...questionArray, formData]);

        if (isActiveQuestion < totalQuestion) {
            setActiveQuestion(isActiveQuestion + 1);
        } else {
            saveQuestionData([...questionArray, formData], false);
        }
    };

    const saveQuestionData = (formData, shouldNavigate) => {
        if (location.pathname.substr(1, 1) === "t") {
            const data = { questions: formData };
            data["test_id"] = result && result.test_id;
            data["result_id"] = result && result.id;
            data["question_type"] = questionType;
            data["guest_token"] = ReactSession.get("guest_token");
            data["time_spent"] = timeSpent;

            if (questionLoading) {
                return false;
            }

            if (!shouldNavigate) {
                setQuestionLoading(true);
            }

            if (shouldNavigate) {
                questionCallback(formData, questionType, false);
            }

            saveTestResultQuestion(data, ReactSession.get("token")).then(
                (response) => {
                    if (!shouldNavigate) {
                        setQuestionLoading(false);
                    }
                    if (response.success) {
                        questionCallback(formData, questionType, response.assignCredits);
                    } else {
                        showToast(response.message, "error");
                    }
                }
            );
        } else {
            questionCallback(formData, questionType, false);
        }
    };

    return (
        <div className="taking-test-page-wrap">
            <div className="container">
                {QuestionArrayList &&
                    QuestionArrayList.map((question, index) => (
                        <div key={index}>
                            {isActiveQuestion === index + 1 && (
                                <GlobalQuestion
                                    test={test}
                                    question={question}
                                    currentStep={isActiveQuestion}
                                    totalSteps={QuestionArrayList.length}
                                    onNext={handleNext}
                                    onSkip={() => {
                                        if (isActiveQuestion < totalQuestion) {
                                            setActiveQuestion(isActiveQuestion + 1);
                                        } else {
                                            saveQuestionData([...questionArray], false);
                                        }
                                    }}
                                    isOptional={question.questionData.is_optional}
                                    timeSpent={timeSpent}
                                    questionType={questionType}
                                    result={result}
                                    questionCallback={questionCallback}
                                    callback={() => { }}
                                    methodology="question"
                                    skippedCount={skippedCount}
                                    onSkipCountChange={setSkippedCount}
                                />
                            )}
                        </div>
                    ))}
            </div>
        </div>
    );
}
